import { LockIcon } from "components/common/Icons/LockIcon";
import { UnlockIcon } from "components/common/Icons/UnlockIcon";
import { Input } from "components/common/Input/Input";
import { useSize } from "./useSize";
import { ToolTip } from "components/common/ToolTip/ToolTip";
import { capitalize } from "client/utils/capitalize";
import { Translate } from "components/common/Translate/Translate";
import { translateFunc } from "client/utils/translateFunc";

export const Size = () => {
    const { height, width, handleHeightChange, handleWidthChange, isLocked, toggleLock } = useSize();

    return (
        <div>
            <div className="flex max-w-full items-end gap-2">
                <div className="flex flex-col min-w-0 gap-2">
                    <div className="capitalize" data-testid={`width-input-label`}>
                        <Translate keyName="width" />
                    </div>
                    <Input
                        type="number"
                        value={Math.floor(width)}
                        min={0}
                        onChange={handleWidthChange}
                        data-testid="enlarge-width-input"
                    />
                </div>
                <ToolTip
                    text={capitalize(
                        isLocked
                            ? translateFunc("locked-icon-tooltip-text")
                            : translateFunc("un-locked-icon-tooltip-text"),
                    )}
                >
                    <div
                        className={`flex-shrink-0 flex items-center justify-center cursor-pointer min-w-0  ${
                            isLocked && "bg-irGray-200 dark:bg-darkSurface-200"
                        } hover:bg-irGray-200 dark:hover:bg-darkSurface-100 border border-irGray-400 dark:border-darkSurface-100 w-12 h-12 rounded-lg`}
                        onClick={toggleLock}
                        data-testid={`lock-container`}
                    >
                        {isLocked ? (
                            <div data-testid="enlarge-lock-icon">
                                <LockIcon />
                            </div>
                        ) : (
                            <div data-testid="enlarge-unlock-icon">
                                <UnlockIcon />
                            </div>
                        )}
                    </div>
                </ToolTip>
                <div className="flex flex-col min-w-0 gap-2">
                    <div className="capitalize" data-testid={`height-input-label`}>
                        <Translate keyName="height" />
                    </div>
                    <Input
                        type="number"
                        value={Math.floor(height)}
                        min={0}
                        onChange={handleHeightChange}
                        data-testid="enlarge-height-input"
                    />
                </div>
            </div>
            <div className="mt-4 text-irGray-600 font-semibold" data-testid={`enlarge-settings-helper-text`}>
                <Translate keyName="units-are-in-pixels" />
            </div>
        </div>
    );
};
